import { render } from "./HdPagination.vue?vue&type=template&id=2fb3ef8e"
import script from "./HdPagination.vue?vue&type=script&lang=js"
export * from "./HdPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__